import React, { useEffect, useState, useRef } from "react";

import NavbarTab from '../NavbarTab.jsx';
import { PortalTrigger } from "../Portal.jsx";
import { FaIcon } from "../Icons.jsx";
import { Modal, closeModal } from "../Modal.jsx";

import DesignConfiguration from './DesignConfiguration.jsx';
import Preview from './Preview.jsx';

const MODAL_ID = "project-report-pdf-modal";
const BULK_DUMMY_ID = 'BULK_DUMMY_ID';

const PdfExportDialog = ({ contentTabProps, ContentTab = null, action, closeDialog = () => {}, isBulkAction = false, previewPath, enableDesign = true, fathomAction = null, defaultParams = {}, queryParams={} }) => {
  const [generating, setGenerating] = useState(false);

  const actionParams = useRef(defaultParams);

  const generatePdf = (e) => {
    setGenerating(true);

    let formData = {
      authenticity_token: $('meta[name="csrf-token"]').attr('content'),
    }

    const u = Object.keys(actionParams.current)
      .map(key => {
        let value = actionParams.current[key];
    
        if (typeof value === 'object' && value !== null) {
          value = JSON.stringify(value);
        }
        return `&${key}=${encodeURIComponent(value)}`;
      })
      .join('');


    if (isBulkAction) {
      formData = {
        ...formData,
        preview_path: previewPath.substring(0, previewPath.lastIndexOf('/')),
        preview_path_end: (previewPath.includes("?") ? '&' : '?') + 'remote=true' + u,
      }
    } else {
      const pdfPath = previewPath + (previewPath.includes("?") ? '&' : '?') + 'remote=true' + u;
      formData = {
        ...formData,
        path: pdfPath
      }
    }

    if (fathomAction) {
      const {name, value} = fathomAction;
      Fathom.trackEvent(name, value);
    }

    // External pdf generation
    jQuery.post(action, formData)
      .done((response) => {
        console.log('PDF generation initiated:', response);
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        console.error('PDF generation failed:', textStatus, errorThrown);
      })
      .always(() => {
        setGenerating(false);
        window.ToastNotification({message: I18n.t('export_started_background_info'), horizontal: 'center', vertical: 'top', autoHideDuration: 5});
        closeModal(MODAL_ID);
      });
  };

  const onConfigChange = (tabContent) => {
    actionParams.current = { ...actionParams.current, ...tabContent };
  };

  return (
    <Modal
      id={MODAL_ID}
      title={I18n.t("pdf_export_form_selection_and_design")}
      onClose={closeDialog}
      onSave={generatePdf}
      focusOnMount={false}
      saveLabel={generating ? I18n.t('exporting') : I18n.t('export')}
      disableSave={generating}
      size="lg"
    >
      <NavbarTab
        alwaysRender={true} //TBD
        tabs={[
          ContentTab ? {
            title: I18n.t("content"),
            alwaysRender: true,
            content: <ContentTab {...contentTabProps} onConfigChange={onConfigChange}/>
          } : null,
          enableDesign ? { 
            title: I18n.t("design"),
            alwaysRender: true,
            content: <DesignConfiguration 
              onConfigChange={onConfigChange} 
              mayManageTemplates={contentTabProps.mayManageTemplates}
            /> 
          } : null,
          { 
            title: I18n.t("preview"),
            alwaysRender: false,
            content: <Preview actionParams={actionParams} action={previewPath || action} queryParams={queryParams} /> 
          },
        ].filter((tab) => tab)}
      />
    </Modal>
  );


}




const PdfButton = ({ btnProps = {}, portalProps = {}, labelProps = {}, iconProps = {type: "download"} }) => {
  const label = (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
      <FaIcon {...iconProps} />
      <div {...labelProps} style={{ marginLeft: '5px', ...labelProps.style }}>
        {btnProps.title ? btnProps.title: I18n.t("pdf")}
      </div>
    </div>
  );

  return (
    <PortalTrigger
      label={label}
      btnProps={btnProps}
      portalProps={{ ...portalProps, component: PdfExportDialog }}
    />
  );
};


export default PdfButton;
